import { CHANNEL_LAYOUT_VALUES } from './channel-layout-values';
import { CHANNEL_VIDEO_LIST_VALUES } from './channel-video-list-values';
import { PLAY_TYPE_VALUES } from './compact-play-type';
import { COMPACT_SHOW_VIDEO_LIST_VALUES } from './compact-show-video-list';
import { INFO_POSITION_VALUES } from './info-position-values';
import { LAYOUT_STYLE_VALUES } from './layout-style-values';
import { MAIN_ACTION_STYLE_TYPES } from './main-action-style-types';
import { MAIN_ITEM_TYPE_VALUES } from './main-item-type-values';
import { SHOW_INFO_VALUES } from './show-info-values';
import { SHOW_MEDIA_TYPE_VALUES } from './show-media-type-values';
import { TITLE_POSITION_VALUES } from './title-position-values';
import { APP_SETTINGS_VERSION_LATEST } from './versions';
import { NAVIGATION_ARROWS_BEHAVIOR } from './navigation-arrows-behavior';
import { THUMBNAIL_BUTTONS_BEHAVIOR } from './thumbnail-buttons-behavior';
import { NAVIGATION_ARROWS_POSITION } from './navigation-arrows-position';
import { SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES } from './show-expanded-video-list-titles';
import { EXPANDED_THEME_VALUES } from './expanded-theme';
import { TEXT_ALIGNMENT_VALUES } from './text-alignment-values';
import { LOAD_MORE_BUTTON_TYPE_VALUES } from './load-more-button-type-values';
import { VIDEO_END_OPTIONS } from './video-end-options';

/* Change default settings here to modify defaults for new installations.
 * Existing installations will not be affected with these changes
 *
 * NOTE! This is not only place where default settings are coming from.
 * */

export const defaultSettings = {
  booleans: {
    autoPlay: false,
    enableVideosSharing: true,
    showChannelCategories: false,
    showChannelShare: true,
    showChannelTitle: true,
    showChannelInfo: false,
    showSearch: true,
    showSignIn: false,
    showChannelTags: true,
    showChannelVideos: true,
    showVideoTitle: true,
    showFullInfo: true,
    showVideoPublisherInList: false,
    showVideoTitleInList: true,
    showVideoDescriptionInList: true,
    showVideoDurationInList: true,
    showTitleForMainItem: true,
    showPublisherForMainItem: true,
    showExpandedVideoInfo: true,
    enableExpandedVideosSharing: true,
    showExpandedSignIn: false,
    showExpandedChannelTitle: false,
    showExpandedVideoTitle: false,
    showExpandedVideoList: true,
    isSingleVideo: false,
    allowComments: false,
    stretchToFullWidth: false,
    useOptimalFontSizes: true
  },
  numbers: {
    thumbnailSpacing: 0,
    containerMargins: 0,
    videoInfoPosition: INFO_POSITION_VALUES.ON_VIDEOS,
    showInfoAction: SHOW_INFO_VALUES.ON_MOUSE_OVER,
    layoutStyle: LAYOUT_STYLE_VALUES.SQUARE,
    channelLayout: CHANNEL_LAYOUT_VALUES.CLASSIC,
    mainItemType: MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER,
    mainItemTitlePosition: TITLE_POSITION_VALUES.CENTER,
    videoListVisibility: CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    videosInRow: 4,
    mainItemOverlayOpacity: 35,
    thumbnailOverlayOpacity: 40,
    sliderHeight: 383,
    showMediaType: SHOW_MEDIA_TYPE_VALUES.COVER_IMAGE,
    numberOfRows: 1,
    playType: PLAY_TYPE_VALUES.IN_FRAME,
    compactShowVideoListType: COMPACT_SHOW_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    mainActionStyleType: MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT,
    settingsVersion: APP_SETTINGS_VERSION_LATEST,
    showExpandedVideoListInfo: SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES.ON_MOUSE_OVER,
    expandedTheme: EXPANDED_THEME_VALUES.DARK,
    navigationArrowsBehavior: NAVIGATION_ARROWS_BEHAVIOR.ON_HOVER,
    thumbnailButtonsBehavior: THUMBNAIL_BUTTONS_BEHAVIOR.ALWAYS,
    navigationArrowsPosition: NAVIGATION_ARROWS_POSITION.OUTSIDE,
    textAlignment: TEXT_ALIGNMENT_VALUES.LEFT,
    loadMoreButtonType: LOAD_MORE_BUTTON_TYPE_VALUES.TEXT,
    videoEndOption: VIDEO_END_OPTIONS.SHOW_VIDEO_COVER
  },
  fonts: {
    language: ''
  },
  colors: {
    compactMenuActionsColor: {
      themeName: 'color-1',
      value: 'rgba(255,255,255,1)'
    },
    compactMenuBackgroundColor: {
      themeName: 'color-5',
      value: 'rgba(65,65,65,1)'
    },
    mainButtonColor: {
      themeName: 'color-8'
    },
    thumbnailOverlayColor: {
      value: 'rgba(0,0,0,0.4)'
    },
    thumbnailButtonsColor: {
      value: 'rgba(255,255,255,1)'
    }
  },
  editMode: 'site'
};
//# sourceMappingURL=default-settings.js.map